/* ================================================================
   MANIFIX – Cart Drawer JS
================================================================ */

(function () {
  'use strict';

  const BUNDLE_HANDLE      = 'starterset-basic-bundle';
  const BUNDLE_BONUS_PRICE = 1750;

  const $ = (sel, ctx = document) => ctx.querySelector(sel);

  function showToast(msg) {
    let t = document.getElementById('mfx-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'mfx-toast';
      t.style.cssText = `
        position:fixed;bottom:80px;left:50%;transform:translateX(-50%) translateY(20px);
        background:#0a0a0a;color:#fff;padding:12px 20px;border-radius:3px;
        font-size:11px;letter-spacing:.04em;opacity:0;pointer-events:none;
        transition:opacity .3s,transform .3s;z-index:9999;font-family:inherit;
        max-width:300px;text-align:center;line-height:1.5;
      `;
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    t.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(t._timer);
    t._timer = setTimeout(() => {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(20px)';
    }, 3500);
  }

  function getBundledSections() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections }
      })
    );
    return sections;
  }

  async function cartAdd(variantId, qty = 1, properties = {}) {
    const sections = getBundledSections();
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', qty);
    if (sections.length > 0) formData.append('sections', sections.join(','));
    Object.entries(properties).forEach(([k, v]) => formData.append(`properties[${k}]`, v));
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    if (!res.ok) throw new Error('cart/add.js failed');
    return res.json();
  }

  async function cartRemoveByHandle(handle) {
    const cart = await (await fetch('/cart.js')).json();
    const line = cart.items.find(i => i.handle === handle);
    if (!line) return;
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
    if (!res.ok) throw new Error('cart/change.js failed');
    return res.json();
  }

  async function cartSetQuantityByHandle(handle, quantity) {
    const cart = await (await fetch('/cart.js')).json();
    const line = cart.items.find(i => i.handle === handle);
    if (!line) return;
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: quantity }),
    });
    if (!res.ok) throw new Error('cart/change.js failed');
    return res.json();
  }

  async function openDrawerWithResponse(addResponse) {
    const cart = await (await fetch('/cart.js')).json();
    cart['sections'] = addResponse['sections'] || {};
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cart }
      })
    );
  }

  async function forceRefresh() {
    const cart = await (await fetch('/cart.js')).json();
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart: cart }
      })
    );
  }

  function initBundleButton() {
    const btn = document.getElementById('mfx-bundle-btn');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      btn.textContent = '…';
      try {
        const variantId = btn.dataset.variantId;
        const response = await cartAdd(variantId, 1, {
          _bonus: 'true',
          _bonus_price: BUNDLE_BONUS_PRICE,
        });
        showToast('Starterset Basic hinzugefügt! 🎉');
        await openDrawerWithResponse(response);
      } catch (e) {
        showToast('Fehler – bitte nochmal versuchen.');
        btn.disabled = false;
        btn.textContent = 'Set einpacken';
      }
    });
  }

  function initRemoverButton() {
    const btn = $('.mfx-remover-add-btn');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      try {
        const variantId = btn.dataset.variantId;
        const response = await cartAdd(variantId, 1);
        showToast('Remover-Set hinzugefügt!');
        await openDrawerWithResponse(response);
      } catch (e) {
        showToast('Fehler – bitte nochmal versuchen.');
        btn.disabled = false;
      }
    });
  }

  function updateSavingsDisplay() {
    const section = document.querySelector('.mfx-discount-section');
    if (!section) return;
    const foilCount = parseInt(section.dataset.foilCount || '0', 10);
    const savingsLine = document.querySelector('.mfx-savings-line');
    if (savingsLine && foilCount >= 3) savingsLine.style.display = 'block';
  }

  function getFoilCount(items) {
    return items
      .filter(i =>
        i.product_type === 'UV-NAGELFOLIEN' ||
        (i.handle && i.handle.includes('nagelfolie'))
      )
      .reduce((sum, i) => sum + i.quantity, 0);
  }

  async function checkAndRemoveBundle() {
    const cart = await (await fetch('/cart.js')).json();
    const foilCount = getFoilCount(cart.items);
    const bundleLine = cart.items.find(i => i.handle === BUNDLE_HANDLE);

    // Regel 1: ohne Nagelfolie im Warenkorb ist das Set nicht gültig
    if (foilCount === 0 && bundleLine) {
      await cartRemoveByHandle(BUNDLE_HANDLE);
      showToast('Starterset entfernt – nur gültig mit mind. 1x UV-Nagelfolie.');
      await forceRefresh();
      return;
    }

    // Regel 2: max. 1 Set pro Nagelfolie im Warenkorb (1 Folie = 1 Set, 2 Folien = 2 Sets, …)
    if (bundleLine && bundleLine.quantity > foilCount) {
      await cartSetQuantityByHandle(BUNDLE_HANDLE, foilCount);
      showToast('Starterset Basic ist auf max. 1x pro UV-Nagelfolie im Warenkorb begrenzt.');
      await forceRefresh();
    }
  }

  function initCartIconListeners() {
    // Beim Klick auf Warenkorb-Icon oder Drawer-Toggle prüfen
    document.querySelectorAll('[aria-controls="cart-drawer"], [href="/cart"]').forEach(btn => {
      btn.addEventListener('click', async () => {
        await checkAndRemoveBundle();
      });
    });
  }

  function init() {
    initBundleButton();
    initRemoverButton();
    updateSavingsDisplay();
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    initCartIconListeners();
  });

  // Nach Drawer-Refresh — Bundle prüfen
  document.addEventListener('cart-drawer:refreshed', () => {
    setTimeout(() => {
      init();
      checkAndRemoveBundle();
    }, 300);
  });

  // Beim Öffnen des Drawers prüfen
  document.addEventListener('cart:open', async () => {
    await checkAndRemoveBundle();
  });

  // Bei Mengenänderungen/Entfernen prüfen (deckt auch +/- Klicks auf das Bundle selbst und auf die Folien ab)
  document.documentElement.addEventListener('cart:change', async (event) => {
    if (event.detail && event.detail.baseEvent === 'line-item:change') {
      await checkAndRemoveBundle();
    }
  });

})();